export const Loader = ({ className }: { className?: string }) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#a)">
        <path
          opacity=".05"
          d="M38.5 24c0-2.752-.783-5.446-2.257-7.77a14.5 14.5 0 0 0-6.07-5.35"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".1"
          d="M38.5 24a14.5 14.5 0 0 0-3.93-9.926"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".3"
          d="M38.5 24c0-1.828-.345-3.639-1.018-5.338"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M37 24v-.082"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </g>
      <g clipPath="url(#b)">
        <path
          opacity=".05"
          d="M16.75 11.443a14.5 14.5 0 0 0-7.2 13.77"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".1"
          d="M16.75 11.443a14.5 14.5 0 0 0-6.631 8.366"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".3"
          d="M16.75 11.443a14.5 14.5 0 0 0-4.114 3.55"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M17.5 12.742l-.07.04"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </g>
      <g clipPath="url(#c)">
        <path
          opacity=".05"
          d="M16.75 36.557a14.5 14.5 0 0 0 15.525-.65"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".1"
          d="M16.75 36.557a14.5 14.5 0 0 0 10.561 1.56"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          opacity=".3"
          d="M16.75 36.557a14.5 14.5 0 0 0 5.132 1.787"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M17.5 35.258l.07.041"
          stroke="currentColor"
          strokeWidth="6"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="a">
          <rect width="32" height="32" fill="white" transform="translate(8 8)" />
        </clipPath>
        <clipPath id="b">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(18.144 45.856) rotate(-120)"
          />
        </clipPath>
        <clipPath id="c">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(45.856 18.144) rotate(120)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
